import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import {Action, Help} from '../../../system/buttons';
import Ranges from '../../../system/ranges';
import {FilePickerModal, FileTypeSound} from '../../../system/gallery';
import {BasicFormElement} from '../../../system/form';

export class SoundWidgetV2Edit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
      showFilePicker: true,
    };
  }

  saveConfiguration = () => {
    this.props.onSave({
      ranges: this.state.ranges,
      interruptSound: this.state.interruptSound,
      loopSound: this.state.loopSound,
    });
  };

  render() {
    return (
      <>
        <BasicFormElement label={'Loop sound in the range'}>
          <Form.Check
            type="checkbox"
            onChange={(e) => this.setState({loopSound: !this.state.loopSound})}
            checked={this.state.loopSound}
          />
        </BasicFormElement>

        <BasicFormElement label={'Interrupt sound by the next range'}>
          <Form.Check
            type="checkbox"
            onChange={(e) =>
              this.setState({interruptSound: !this.state.interruptSound})
            }
            checked={this.state.interruptSound}
          />
        </BasicFormElement>
        <h4>Configured ranges</h4>
        <Ranges
          ranges={this.state.ranges}
          onRangesChange={(ranges) => this.setState({ranges})}
          defaultRange={{
            from: 60,
            to: 90,
          }}
          header={
            <Col md={7}>
              <Form inline>
                <Col>Sound</Col>
                <Col>Volume(in %, max 100)</Col>
                <Col>Speed</Col>
              </Form>
            </Col>
          }
          rangeConfiguration={(range, onRangeChange) => (
            <Col md={7} key={range.from}>
              <Form inline>
                <Col>
                  <FileForm onRangeChange={onRangeChange} range={range} />
                </Col>
                <Col>
                  <Form.Control
                    as="select"
                    ref="speedSelect"
                    value={range.volume}
                    onChange={(e) => {
                      onRangeChange({
                        ...range,
                        volume: parseInt(e.target.value),
                      });
                    }}
                  >
                    {[0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                      (volume) => (
                        <option value={volume}>{volume}</option>
                      )
                    )}
                  </Form.Control>
                </Col>
                <Col>
                  <Form.Control
                    as="select"
                    ref="speedSelect"
                    value={range.playbackRate}
                    onChange={(e) => {
                      onRangeChange({
                        ...range,
                        playbackRate: parseFloat(e.target.value),
                      });
                    }}
                  >
                    <option value={0.5}>0.5</option>
                    <option value={1.0}>1.0</option>
                    <option value={1.2}>1.2</option>
                    <option value={1.5}>1.5</option>
                    <option value={1.7}>1.7</option>
                    <option value={2.0}>2.0</option>
                  </Form.Control>
                </Col>
              </Form>
            </Col>
          )}
        />
        <div>&nbsp;</div>
        <Action onClick={this.saveConfiguration}>Save settings</Action>
      </>
    );
  }
}

class FileForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showFilePicker: false,
    };
  }

  render() {
    let name = 'Choose file';
    if (this.props.range.file) {
      name = this.props.range.file.name;
      if (name.length > 20) {
        name = name.slice(0, 20) + '...';
      }
    }
    return (
      <>
        {this.state.showFilePicker && (
          <FilePickerModal
            fileType={FileTypeSound}
            show={this.state.showFilePicker}
            hide={() => this.setState({showFilePicker: false})}
            onChoose={(file) => {
              this.setState({showFilePicker: false}, () =>
                this.props.onRangeChange({
                  ...this.props.range,
                  file,
                })
              );
            }}
          />
        )}
        <Help onClick={() => this.setState({showFilePicker: true})}>
          {this.props.range.file ? name : 'Select file'}
        </Help>
      </>
    );
  }
}
